import { IViewModel } from '../../interfaces/view-model.interface';

export class DisplayTimeAndHoursOffset implements IViewModel {
    public id: number = 0;

    public displayTime: string;
    public hoursOffset: number;
}
